// import Vue from "vue";
import Vuex from "vuex";
import accountinfo from "./modules/account"
import privateModule from './modules/privateFund'
import IOS from "../components/ios";
Vue.use(Vuex);

export default new Vuex.Store({
  namespaced: true,
  state: {
    shareInfo:{},//从外部打开app携带的参数
    screeningObj:{},//从外部打开app携带的参数
    copyPromptsInfo:{},//私募详情 底部添加文案提示
    nativeBuriedInfo:{},//索取H5推送到原生的埋点数据
    screeningInfo:{},//原生进入筛选给h5的信息
    pageStatus:'',//页面变化
    deviceId:'',//手机设备id
    pageSource: '', //跳转from路径
    loadingStatus: false, //是否显示加载中
    loadingNum: 0,
    EvaluationResults: {}, // 风险测评结果
    title: "加载中...", // loading描述
    backActive: false, // 测评返回
    headerBg: false,
    showMoreHeader: true,
    setHeader: {},
    childProId: "",
    showScreening: false,
    fromPlatform: '',
    riskLevel: '',
    orgId: '',
    loadingPage: '',
    getOpenAccount: {},
    getHeadInfo: {},
    getGroupObj: null,
    submitPhoneNum: '',
    defaultUpload: [],
    getProfessional: '',
    themeCompany: [],
    statusHeight: {},
    baseData: {},
    routerList: [],
    clickType: '', //1单条，2一键认证
    circleData: {},
    orgDetail: {}, //机构详情
    personalRealInfo: {}, //实名信息--个人
    personalAccount: {}, //账户信息--个人
    newPersonalAccount: {}, //账户信息新方法 
    returnUserInfo: {},
    examFlag: '0',
    personInfoId: {},
    routePathList: [],
    accountCompany: '',
    accountSource: '',
    returnBtn: '0',
    customName: '',
    dictionaryData: [],
    thirdProvinceInfo: [],
    countryInfo: [],
    investReviewList: [], //投资检视
    openDay: '',
    pageInfo: {},
    parentIdInfo: {},
    survivalType: '', //1公募，2私募
    accountIn: false, //账户页面进入风测 --header返回
    customerServicePhone: '', //客服热线
    bindCardPageInfo: {}, //绑卡信息回显--个人中心个人
    taxVal: {}, // 税收值
    trendParams: {}, //公募存续详情走势图参数
    survivalT: '0', //公募存续详情走势图参数
    orgInfo: {}, //机构开户信息
    orgAccountInfo: {}, //机构集团开户返回信息
    controlData: [], //机构失控人信息
    orgBankInfo: {},
    realInfoS: {},
    riskTitle: [],
    uploadChoice: '', //合格投资者保存
    uploadList: {},
    professionList: [], //职业
    defaultPriNum: 0,
    defaultPubNum: 0,
    saleType: '',
    curFundCode: '', //基金代码，投资检视
    curFundId: '', //产品Id

    //gs
    formInfoObj: null,
    riskMomentJumpData: null,
    routeStr: null, //路由标志
    newFoundItem: null,
    scrollHeaderFlag_new: false,
    toNotice: '0',
    NewProductData: null,
    isRiskFlag: "0",

    // formInfoBank:null
    companyId: '', //店中店携参
    notFromNative: false, //原生H5跳转问题
    fromTransPage: false, //问题
    getThemeCode: {},
    priTraInfo: {}, //私募走势数据
    investorFlag: '',
    centerFlag: '0',
    selfVerify: [],
    privateRf: '0',
    publicRf: '0',
    fromAccountInfo: false, //账户页面进入
    detailFlag: '0',
    noIdentity: {}, // 非身份证开户数据
    noIdentityUpload: [], // 非身份证
    UploadFile: [], // 个人中心上传材料
    //确认补录
    personalConfirmationPageInfo: null, //个人确认页
    orgConfirmationPageInfo: null, //机构确认页
    addConfirmationPageInfo: null, //补录页
    taxValObj: null, //补录页
    repeatRisk: '0',
    survivalActive: 0,
    skipList: [],
    clientArea: {},
    proTag: 1,
    privateListF: 0,
    enforceFlag: '0',
    riskReason: {},
    reasonSource: '',
    recordTab: '',
    isWatcher: null,
    selectedAssetsArr: [], //已选择指定资产
    choosedReasonObj: {}, //已选择申请原因
    isAllSelected: false, //是否全选
    privateChartTab: '0',
    fundTypeVx: "", //基金类型

    jumpBreackfastData:null,//跳转财经早餐-参数
    shareDetail:null,
    openId:null,//财经早餐id
    isApp:true,
    hideView:0,//截图头部保存状态
    deviceInfo:{}, //手机设备信息
    deviceInfoH5: null, //H5获取 手机设备信息
    pkInfo: {}, // 基金对比信息
    batchBuyList:[],//批量买入数据
    scrollY: 0, // 页面滚动距离
    stockAndBond: {}, // 股债利差
    productList:[],//查询出来的产品列表
    managerList:[],//查询出来的基金列表
    historyUnitSource:'',//进入历史净值更过页面来源1:私募，2：资产私募
    verifyStatus:{},//status:0否1是，1显示弹窗,baseUrl:点击加入购物车接口
    getOpenAccountInfo:{},//开户信息
    showCurrentPageLayer:{},//显示当前页面弹框
    shoppingLayerInfo:{},//购物车蒙层信息
    batchOrderInfo:{},//批量订单信息
    shareImage:false,

    //优化后从原生取到的基础信息
    baseInfoFromNative:{},
    // 私募分享参数
    primaryDetailShare:{},
    isNonShowSubScribeMail: false, //是否不显示订阅邮箱,兼容原生,默认为显示
    homeFromPage: false, //是否来源首页
    scrollPositions: {},
    //资产可见不可见
    eyeStatus: 'close',
    fixedPlanAlertState: false, //首页定投弹框是否弹出
  },
  mutations: {
    //管理资产可视状态
    toggleEyeStatus(state) {
      console.log(state.eyeStatus,'切换眼睛');
      state.eyeStatus = state.eyeStatus === 'open' ? 'close' : 'open';
      var json = { eyeState: state.eyeStatus == 'open' ? '1' : '0' }
      if (!IOS.ios()) {
        json = JSON.stringify(json)
      }
      dsBridge.call(
        "setLocalStorageJson",
        json,
        function (responseData) {
          console.log("responseData:", responseData);
        }
      );
    },
    saveScrollPosition(state, payload) {
      state.scrollPositions = payload
    },
    changeShareImage(state, data) {
      state.shareImage = data
    },
    getBatchOrderReturnInfo(state, data) {
      state.batchOrderInfo = data
    },
    getLayerFromNative(state, data) {
      state.shoppingLayerInfo = data
    },
    controlLayerStatus(state, data) {
      state.showCurrentPageLayer = data
    },
    changeVerifyStatus(state, data) {
      state.verifyStatus = data
    },
    changeHistorySource(state, data) {
      state.historyUnitSource = data
    },
    changeAccountInfo(state, data) {
      state.getOpenAccountInfo = data
    },
    changeHideView(state, data) {
      state.hideView = data
    },
    changeIsApp(state, data) {
      state.openId = data
    },
    changeOpenId(state, data) {
      state.openId = data
    },
    shareDetailM(state, data) {
      state.shareDetail = data
    },
    jumpBreackfastDataM(state, data) {
      state.jumpBreackfastData = data
    },
    //从外部打开基金筛选
    setScreeningObj(state,data){
      state.screeningObj=data
    },
    //从外部打开app携带的参数
    setShareObj(state,data){
      state.shareInfo=data
    },
    //私募详情 底部添加文案提示
    setCopyPrompts(state,data){
      state.copyPromptsInfo=data
    },
    //索取H5推送到原生的埋点数据
    getBuriedInfo(state, data){ 
      state.nativeBuriedInfo=data
    },
    //原生进入筛选页面
    getScreeningInfo(state, data){
      state.screeningInfo = data
    },
    //通知H5 ，当前加载页面得状态变化
    getPageStatus(state, data){
      state.pageStatus = data
    },
    //手机信息
    userPhoneInfo(state, data) {
      state.deviceId = data
    },
    //手机设备信息
    changeDeviceInfo(state, data) {
      state.deviceInfo = data
    },
     //H5获取手机设备信息
     changeDeviceInfoH5(state, data) {
      state.deviceInfoH5 = data
    },
    //更改from路径
    changePageSource(state, data) {
      state.pageSource = data
    },
    //已选择指定资产
    changeAssetsArr(state, data) {
      state.selectedAssetsArr = data
    },
    //已选择申请原因
    choosedReason(state, data) {
      state.choosedReasonObj = data
    },
    //是否全选资产
    changeAllAssets(state, data) {
      state.isAllSelected = data
    },

    //补录页-税收
    changeTaxValObj(state, data) {
      state.taxValObj = data
    },
    //补录页
    changeAddConfirmationPageInfo(state, data) {
      state.addConfirmationPageInfo = data
    },
    //个人确认页
    changePersonalConfirmationPageInfo(state, data) {
      state.personalConfirmationPageInfo = data
    },
    //机构确认页
    changeOrgConfirmationPageInfo(state, data) {
      state.orgConfirmationPageInfo = data
    },
    //用户开户是否风测
    changeRiskFlag(state, data) {
      state.isRiskFlag = data
    },
    //新品首发去公募详情
    getNewProductData(state, data) {
      state.NewProductData = data
    },
    //新品首发去公告
    changeToNotice(state, data) {
      state.toNotice = data
    },
    //新品首发传参header--滚动事件
    changeScrollHeaderFlag_new(state, data) {
      state.scrollHeaderFlag_new = data
    },
    //新品首发传参header--基金信息
    changeFoundName(state, data) {
      state.newFoundItem = data
    },
    //从账户页面进入页面跳转
    changeFromAccountInfo(state, data) {
      state.fromAccountInfo = data
    },
    //绑卡中转
    changeBackStatus(state, data) {
      state.fromTransPage = data
    },
    //财富顾问
    changeNotFromNative(state, data) {
      state.notFromNative = data
    },
    //店中店携参
    changeCompanyId(state, data) {
      state.companyId = data
    },
    //走势图参数
    changeTrendParams(state, data) {
      state.trendParams = data
    },
    //绑卡信息
    changeBindCardPageInfo(state, data) {
      state.bindCardPageInfo = data
    },
    //个人页面路由跳转参数--注册=>表单页面2
    changeFormInfoObj(state, data) {
      state.formInfoObj = data
    },
    //个人页面路由跳转参数--注册=>风测结束去银行卡
    // changeFormInfoBank(state, data) {
    //   state.formInfoBank = data
    // },
    //客服热线
    changeServicePhone(state, data) {
      state.customerServicePhone = data
    },
    //账户页面进入风测
    changeAccountIne(state, data) {
      state.accountIn = data
    },
    //存续类型
    changeSurvivalType(state, data) {
      state.survivalType = data
    },
    //投资检视
    changeInvest(state, data) {
      state.investReviewList = data
    },
    chanLoadingStatus(state, data) {
      state.loadingStatus = data
    },
    changeLoadingNum(state, data) {
      state.loadingNum = data
    },
    // 风险测评结果
    changeResults(state, data) {
      state.EvaluationResults = data
    },
    // kaihu
    changeOpenAccount(state, data) {
      state.getOpenAccount = data
    },
    // kaihu请求头
    getCommonInfo(state, data) {
      state.getHeadInfo = data
    },
    getBaseInfoFromNative(state, data) {
      state.baseInfoFromNative = data
    },
    // loading标题
    changeTitle(state, data) {
      state.title = data
    },
    // 返回键监听
    changeBack(state, data) {
      state.backActive = data
    },
    // 头部背景色
    changeBg(state, data) {
      state.headerBg = data
    },
    changeHeaderBg(state, data) {
      state.showMoreHeader = data
    },
    changeSetHeader(state, data) {
      state.setHeader = data
    },
    changeProductId(state, data) {
      state.childProId = data
    },
    changePrimaryDetailShare(state, data) {
      state.primaryDetailShare = data
    },
    switchScreening(state, data) {
      state.showScreening = data
    },
    savePlatform(state, data) {
      state.fromPlatform = data
    },
    saveRiskLevel(state, data) {
      state.riskLevel = data
    },
    getOrgCommonId(state, data) {
      state.orgId = data
    },
    changeLoading(state, data) {
      state.loadingPage = data
    },
    getGroupFun(state, data) {
      state.getGroupObj = data
    },
    setNumber(state, data) {
      state.submitPhoneNum = data
    },
    changeUploadVal(state, data) {
      state.defaultUpload = data
    },
    changeProfessional(state, data) {
      state.getProfessional = data
    },
    getThemeCompany(state, data) {
      state.themeCompany = data
    },
    getStatusHeight(state, data) {
      state.statusHeight = data
    },
    getBaseData(state, data) {
      state.baseData = data
    },
    getSaleType(state, data) {
      state.saleType = data
    },
    getTurnPage(state, data) {
      state.routerList = data
    },
    getClickType(state, data) {
      state.clickType = data
    },
    changeCircleValue(state, data) {
      state.circleData = data
    },
    getOrgId(state, data) {
      state.orgDetail = data
    },
    getPersonalRealInfo(state, data) {
      state.personalRealInfo = data
    },
    getPersonalAccount(state, data) {
      state.personalAccount = data
    },
    getNewPersonalAccount(state, data) {
      state.newPersonalAccount = data
    },
    getAssetsPageInfo(state, data) {
      console.log("store-资产", data)
      state.personalAccount = data
    },
    fillUserInfo(state, data) {
      state.returnUserInfo = data
    },
    changeExamStatus(state, data) {
      state.examFlag = data
    },
    changeInfoId(state, data) {
      state.personInfoId = data
    },
    changePathList(state, data) {
      state.routePathList = data
    },
    changeLocalId(state, data) {
      state.accountCompany = data
    },
    getSourceVal(state, data) {
      state.accountSource = data
    },
    changeReturnParam(state, data) {
      state.returnBtn = data
    },
    changeInfo(state, data) {
      state.customName = data
    },
    changeDictionary(state, data) {
      state.dictionaryData = data
    },
    getProvinceInfo(state, data) {
      state.thirdProvinceInfo = data
    },
    getCountryInfo(state, data) {
      state.countryInfo = data
    },
    changeOpenDate(state, data) {
      state.openDay = data
    },
    routerJump(state, data) {
      state.routeStr = data
    },
    changePageInfo(state, data) {
      state.pageInfo = data
    },
    changeParentInfo(state, data) {
      state.parentIdInfo = data
    },
    changeTaxVal(state, data) {
      state.taxVal = data
    },
    changeSurvivalT(state, data) {
      state.survivalT = data
    },
    changeOrgInfo(state, data) {
      state.orgInfo = data
    },
    changeOrgAccountInfo(state, data) {
      state.orgAccountInfo = data
    },
    changeControlData(state, data) {
      state.controlData = data
    },
    changeOrgBankInfo(state, data) {
      state.orgBankInfo = data
    },
    changeRealInfoS(state, data) {
      state.realInfoS = data
    },
    changeRiskTitle(state, data) {
      state.riskTitle = data
    },
    changeUploadChoice(state, data) {
      state.uploadChoice = data
    },
    changeUploadList(state, data) {
      state.uploadList = data
    },
    changeProfessionList(state, data) {
      state.professionList = data
    },
    changeDefaultPriNum(state, data) {
      state.defaultPriNum = data
    },
    changeDefaultPubNum(state, data) {
      state.defaultPubNum = data
    },
    changeCurFundCode(state, data) {
      state.curFundCode = data
    },
    changeCurFundId(state, data) {
      state.curFundId = data
    },
    changeGetThemeCode(state, data) {
      state.getThemeCode = data
    },
    changePrivateInfo(state, data) {
      state.priTraInfo = data
    },
    changeInvestorFlag(state, data) {
      state.investorFlag = data
    },
    changeCenterFlag(state, data) {
      state.centerFlag = data
    },
    changeSelfVerify(state, data) {
      state.selfVerify = data
    },
    changePrivateRf(state, data) {
      state.privateRf = data
    },
    changeDetailFlag(state, data) {
      state.detailFlag = data
    },
    changeNoIdentity(state, data) {
      state.noIdentity = data
    },
    changeNoIdentityUpload(state, data) {
      state.noIdentityUpload = data
    },
    changeUploadFile(state, data) {
      state.UploadFile = data
    },
    changeRepeatRisk(state, data) {
      state.repeatRisk = data
    },
    changeSurTab(state, data) {
      state.survivalActive = data
    },
    changePriTab(state, data) {
      state.privateChartTab = data
    },
    changeSkipList(state, data) {
      state.skipList = data
    },
    changeClientArea(state, data) {
      state.clientArea = data
    },
    changeProTag(state, data) {
      state.proTag = data
    },
    changePrivateListF(state, data) {
      state.privateListF = data
    },
    changeEnforceFlag(state, data) {
      state.enforceFlag = data
    },
    changeReasonState(state, data) {
      state.riskReason = data
    },
    changeReasonInfo(state, data) {
      state.reasonSource = data
    },
    changeRecordActive(state, data) {
      state.recordTab = data
    },
    changeIsWatcher(state, data) {
      state.isWatcher = data
    },
    changeFundTypeValue(state, data) {
      state.fundTypeVx = data
    },
    changePkInfo(state, data) {
      state.pkInfo = {...data}
    },
    changeRecruitScrollY(state, data) {
      state.scrollY = data
    },
    changeBuyListData(state, data) {
      state.batchBuyList = data
    },
    changeStockAndBond(state, data) {
      state.stockAndBond = { ...data }
    },
    changeProductList(state, data) {
      state.productList = data
    },
    changeManagerList(state, data) {
      state.managerList = data
    },
    changeSubScribeMailState(state, data) {
      state.isNonShowSubScribeMail = data
    },
    setHomeFromPage(state, data) {
      state.homeFromPage = data
    },
    setNativeTab(state, data) {
      state.hiddenNativeTab = data
    },
    changeFastAuthenticationStatus(state, data) {
      state.fastAuthenticationStatus = data
    },
    setFixedPlanAlertState(state, data) {
      state.fixedPlanAlertState = data
    }
  },
  actions: {
    //投资检视
    getInvest(context, data) {
      context.commit("changeInvest", data)
    },
    getLoadingNum(context, data) {
      context.commit("changeLoadingNum", data)
    },
    // 风险测评结果
    getResults(context, data) {
      context.commit("changeResults", data)
    },
    // 开户
    getOpenAccount(context, data) {
      context.commit("changeOpenAccount", data)
    },
    getTitle(context, data) {
      context.commit("changeTitle", data)
    },
    // 返回键监听
    getBack(context, data) {
      context.commit("changeBack", data)
    },
    // 头部背景
    getBg(context, data) {
      context.commit("changeBg", data)
    },
    getChangeBg(context, data) {
      context.commit("changeHeaderBg", data)
    },
    getSetHeader(context, data) {
      context.commit("changeSetHeader", data)
    },
    getProductId(context, data) {
      context.commit("changeProductId", data)
    },
    getCurFundCode(context, data) {
      context.commit("changeCurFundCode", data)
    },
    setBaseInfoFromNatvie(context,data){
      context.commit("getBaseInfoFromNative", data)
    }
  },
  modules: {
    accountinfo,
    privateModule
  }
});